import React from 'react'
import ReactDOM from 'react-dom'
import { createGlobalStyle } from 'styled-components'
import { SignatureBuilder } from './components/SignatureBuilder/SignatureBuilder'

const App = () => {
	const GlobalStyle = createGlobalStyle`

	@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;300;500&display=swap');

	body {
		margin: 0;
		font-family: 'Montserrat', sans-serif;
		font-weight: 300;
	}
	@keyframes flipdown {
		0% {
			opacity: 0;
			transform-origin: top center;
			transform: rotateX(-90deg);
		}
		90% {
			opacity: 1;
		}
		100% {
			transform-origin: top center;
			transform: rotateX(0deg);
		}
	}
	`
	return (
		<>
		<GlobalStyle />
		<SignatureBuilder />
		</>
		)
}

ReactDOM.render(
	<React.StrictMode>
	<App />
	</React.StrictMode>,
	document.getElementById('root')
	);
